<template>
  <div class="container row" id="small-header" :class="{'active':parent.currentProjectView!==null}">
    <a
      class="project-image-container col-md-6 col-sm-12"
      :class="{'active-project col-md-12':parent.currentProjectView===project, 'floating':parent.currentProjectView!==project&&parent.currentProjectView!==null}"
      v-for="( project, index) in parent.projects"
      :key="index"
      @click="animateInProject(project)"
    >
      <div
        class="project"
        v-lazy:background-image="parent.getImageUrl(project.cover)"
        :key="parent.getImageUrl(project.cover)"
      >
        <div
          class="project-view-title animated"
          :style="{
                'background-color':project.bgColor
              }"
        >
          <span class="project-name animated">{{project.name}}</span>
          <span class="project-category animated">{{project.category}}</span>
        </div>
      </div>
    </a>
    <div
      v-if="parent.layout==='md'&&parent.currentProjectView===null"
      class="copyright animated"
    >COPYRIGHT © {{parent.getYear()}} WILLIAM SOO - GRAPHIC DESIGNER</div>
  </div>
</template>

<script>
//import ProjectNav from "../components/project-nav.vue";

export default {
  name: "project-header",
  components: {
    //ProjectNav
  },
  props: ["parent"],
  mounted() {
    this.parent.enableScroll();
  },
  methods: {
    animateInProject(p) {
      this.parent.currentProjectView = p;
      this.parent.selectedProject = p;
      this.$eventBus.$emit("showFixedHeader");
      window.scrollTo(0, 0);

      document
        .getElementById("project-gallery")
        .classList.add("active", "animated", "fadeInUp", "slow");
    }
  },
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.copyright {
  flex: 0 0 100%;
  position: static;
  font-size: 0.75rem;
  padding-left: 4px;
}

#small-header.active {
  padding: 0 !important;
}
.container {
  padding: 0.25rem;
}

.project-image-container {
  height: 600px;
  padding: 0.25rem;
  box-sizing: border-box;
  transition: all 1.2s ease;
}

.project {
  padding: 0.875rem;
  width: 100%;
  height: calc(100% - 100px);
  background-position: center center;
  transition: all 0.4s ease;
  background-size: cover;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;
}

.project-view-title {
  margin-right: -50px;
  text-align: center;
  left: 0;
  height: 100px;
  width: 100%;
  position: absolute;
  bottom: -100px;
  display: flex;
  flex-direction: column;
  color: white;
}
.project-name {
  transform: translateY(-25px);
  font-size: 2rem;
  font-weight: bold;
}
.project-category {
  transform: translateY(-12px);
  text-transform: uppercase;
}
.active-project {
  width: 100%;
  height: 600px;
  float: right;
  padding: 0;
}

.floating {
  position: absolute;
  top: 0;
  z-index: -1;
}
</style>
